import React from "react";
// Components
import helper from "../../../../helper/helper";
// typo
import typo, {MESSAGE} from "../../../../constants/dictionaries";
import InputNumber from "../../../Common/NumberField"
import Select from "../../../Common/Select";
const dataSelect = [
  {name: "=",value: "=",},
  {name: ">",value: ">",},
  {name: "<",value: "<",},
]
const columns = ({ } = {}) =>
  [
    {
      // key: "",
      title: "TT",
      dataIndex: "stt",
      width: "40px",
    },
    {
      // key: "",
      title: "Ký hiệu",
      dataIndex: "thongso_kyhieu",
      width: "20%",
    },
    {
      // key: "",
      title: "Tên thông số",
      dataIndex: "thongso_ten",
    },
    {
      // key: "",
      title: "",
      dataIndex: "miengiatri",
      width: "70px",
      render: (value, row) =>
       <div>
        <Select
          dataSource={dataSelect}
          defaultValue={value ? value : "="}
          onChange={value => {row.miengiatri = value}}
          mandatory={false}
          width="100%"
          name="name"
          name_value="value"
          
        />
       </div>,
    },
    {
      // key: "",
      title: "Giá trị",
      dataIndex: "giatri",
      width: "100px",
      render: (value, row) =>
       <div>
        <InputNumber 
          placeholder={typo.cscore_value} 
          mandatory={false} 
          width="100%"
          defaultValue={value ? value : 0}
          onChange={value => row.giatri = value}
        />
       </div>,
    },
    {
      // key: "",
      title: "Đơn vị",
      dataIndex: "donvi_ten",
      width: "15%",
    },
  ].map(col => ({
    ...col
  }));

export default columns;
